/**
 * AIFeedbackWidget — Sprint 3 V3
 * ================================
 * Petits boutons 👍/👎 placés sous toute réponse IA importante.
 * Tracking dans `ai_response_feedback` pour pilotage qualité.
 */
import { useState } from 'react';
import api from '../../lib/api';
import { ThumbsUp, ThumbsDown, Check } from 'lucide-react';
import { toast } from 'sonner';

export default function AIFeedbackWidget({ feature, responseId, mandateId, modelUsed, size = 'sm', label = "Cette réponse vous a été utile ?" }) {
    const [submitted, setSubmitted] = useState(null);

    const submit = async (rating) => {
        if (submitted) return;
        try {
            await api.post('/ai/feedback', {
                feature,
                rating,
                response_id: responseId || null,
                mandate_id: mandateId || null,
                model_used: modelUsed || null,
            });
            setSubmitted(rating);
            toast.success(rating === 'positive' ? 'Merci !' : 'Merci, on s\'améliorera');
        } catch (e) {
            toast.error('Feedback non envoyé');
        }
    };

    if (submitted) {
        return (
            <div className="inline-flex items-center gap-1.5 text-xs text-emerald-600" data-testid={`ai-feedback-${feature}-done`}>
                <Check className="w-3.5 h-3.5" /> Merci pour votre retour
            </div>
        );
    }

    const btn = size === 'lg' ? 'p-2' : 'p-1.5';
    return (
        <div className="inline-flex items-center gap-2 text-xs text-slate-500" data-testid={`ai-feedback-${feature}`}>
            <span>{label}</span>
            <button
                onClick={() => submit('positive')}
                className={`${btn} hover:bg-emerald-50 hover:text-emerald-600 rounded-md transition-colors`}
                title="Utile"
                data-testid={`ai-feedback-${feature}-up`}
            >
                <ThumbsUp className="w-4 h-4" />
            </button>
            <button
                onClick={() => submit('negative')}
                className={`${btn} hover:bg-red-50 hover:text-red-600 rounded-md transition-colors`}
                title="Pas utile"
                data-testid={`ai-feedback-${feature}-down`}
            >
                <ThumbsDown className="w-4 h-4" />
            </button>
        </div>
    );
}
